import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

let routes = [
	{
		path: '/',
		name: 'home',
		component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
		props: { adsType: 'home_insert' },
	},
	{
		path: '/:channel(channel[1-9]\\d?)',
		name: 'homechannel',
		component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
		props: (route) => ({ ...route.params, adsType: 'home_insert' }),
		beforeEnter: (to, from, next) => {
			console.log(`访问的是 /${to.params.channel}`)
			next()
		},
	},
	{
		path: '/privacy-policy',
		name: 'privacy',
		component: () => import('../pages/privacy.vue'),
		props: { adsType: 'detail_masonry' },
	},
	{
		path: '/terms-of-services',
		name: 'terms',
		component: () => import('../pages/terms.vue'),
		props: { adsType: 'detail_masonry' },
	},
	{
		path: '/disclaimer',
		name: 'disclaimer',
		component: () => import('../pages/disclaimer.vue'),
		props: { adsType: 'detail_masonry' },
	},
	{
		path: '/:channel(channel[1-9]\\d?)/tag/:tag',
		name: 'tagchannel',
		component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
		props: (route) => ({ ...route.params, adsType: 'detail_masonry' }),
		beforeEnter: (to, from, next) => {
			console.log(`访问的是 /${to.params.channel}/tag/${to.params.tag}`)
			next()
		},
	},
	{
		path: '/:channel(channel[1-9]\\d?)/:imgid',
		name: 'imgidchannel',
		component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
		props: (route) => ({ ...route.params, adsType: 'detail_masonry' }),
		beforeEnter: (to, from, next) => {
			console.log(`访问的是 /${to.params.channel}/${to.params.imgid}`)
			next()
		},
	},
	{
		path: '/tag/:tag',
		name: 'tag',
		component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
		props: { adsType: 'detail_masonry' },
	},
	{
		path: '/:imgid',
		name: 'imgid',
		component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
		props: { adsType: 'detail_masonry' },
	},
	// 最后放置通配路由
	{
		path: '*',
		redirect: { name: 'home' },
	},
]

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
